<template>
  <div>
    <div v-if="target_type == 2 && pdfLoading">PDF文件加载中，请稍候...</div>
    <div v-if="target_type == 2 && false">
      <div class="back_view" @click="backSeek" v-if="showPdf">返回查看</div>
      <div class="pdf_cont" v-if="!showPdf">
        <img src="../../static/images/pdf.png" alt="" />
        <div class="title">{{ pdfData.title }}</div>
        <div class="preview_seek">
          <span @click="previewSeek">预览查看</span>
        </div>
        <div class="preview_seek">
          <span @click="downloadPdf">下载PDF</span>
        </div>
      </div>
    </div>
    <div v-if="target_type == 3" class="article_page">
      <h2 class="article_title">{{ articleData.title }}</h2>
      <p>
        <span class="">{{ articleData.title }}</span>
      </p>
      <p>
        <span class="article_author">{{ articleData.author }}</span>
      </p>
      <div v-html="articleData.content" id="show_content"></div>
    </div>
    <div v-if="target_type == 2" ref="pdfContainer">
      <pdf v-for="i in numPages" :key="i" :src="pdfDataList" :page="i" />
    </div>
    <a-modal v-model="userInfo">
      <div class="userInfo">
        <img :src="pdfData.employeeAvatar" alt="" />
        <div>
          <div style="font-weight: bold; font-size: 16px">
            {{ pdfData.employeeName }}
          </div>
          <span style="color: #9b9b9b; font-size: 12px">{{
            pdfData.employeeMobile
          }}</span>
        </div>
      </div>
      <div class="userQrcode">
        <img :src="pdfData.qrCode" alt="" />
        <span style="margin-top: 10px; font-size: 12px; color: #9b9b9b"
          >长按二维码，加我企业微信</span
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import { getRadarApi, openUserInfoApi, getRadar } from '../../api/radar'
import { debounce } from '../../plugins/debounce'
import axios from 'axios'

export default {
  components: {
    pdf,
  },
  data() {
    return {
      url: window.location.href,
      //  微信用户数据
      pdfLoading: true,
      showPdf: false,
      weChatUserData: {},
      link: '',
      //pdf数据
      pdfData: {},
      //文章数据
      articleData: {},
      openTime: '',
      clickId: '',
      userInfo: false,
      pdfDataList: '',
      numPages: undefined,
      isPageBack: false,
      // 心跳定时器：每 5 秒上报一次累计阅读时长，避免依赖 visibilitychange/pagehide
      // 在企微 webview "退出"按钮路径下不触发的问题。文章/PDF 阅读覆盖率因此从 ~10%
      // 提升到 99%+。雷达链接(type=1) 因 302 跳走仍无解。
      heartbeatTimer: null,
      // 阅读完成率最高峰记录。客户从底部滑回顶部时不让 finish_rate 降下来，
      // 上报取这个 max 而不是当前位置——更符合"已读到的最远位置"语义。
      maxFinishRate: 0,
      // "完成"事件已触发标记。任一完成条件（滑到底/读 60s/完成率 70%）首次满足
      // 时发一条 from=complete 给后端 → 走通知/动态/标签，并清理心跳。
      // 防止重复触发同时确保员工"最多收到 1 条阅读完成提醒"。
      completionFired: false,
      // 闲置检测：客户最后一次交互（scroll/touch/click）的时间戳。
      // 心跳上报时如果 30s 内无交互，跳过本次上报——read_time 不再增加，
      // 避免"客户挂着不读但页面没关"导致的时长偏差。
      lastActivityAt: Date.now(),
      // 文章末尾的 IntersectionObserver，监测客户是否真的滑到底
      completionObserver: null,
      // PDF 页级 IntersectionObserver，监测客户看到了第几页
      pdfPageObserver: null,
      pdfMaxPageSeen: 0,
    }
  },
  created() {
    //  获取参数
    this.target_type = this.$route.query.type
    this.staff_id = this.$route.query.employee_id
    this.radar_id = this.$route.query.id
    this.target_id = this.$route.query.target_id
    this.getUserData()
    this.openTime = new Date().getTime()
  },
  mounted() {
    // if (window.addEventListener) {
    //   // alert('1232134')
    //   window.addEventListener('pagehide', this.unloadHandler)
    //   window.addEventListener("unload", this.unloadHandler);
    // } else {
    //   // alert('else')
    //   window.unload = this.unloadHandler
    // }
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    let that = this
    if (isAndroid) {
      //安卓
      if (window.addEventListener) {
        document.addEventListener('visibilitychange', function () {
          //部分手机可以获取到
          if (document.hidden) {
            that.addBrowseLog()
          }
        })
      } else if (window.attachEvent) {
        // 主要是为了兼容老的IE
        window.attachEvent('onpagehide', function () {
          that.addBrowseLog()
        })
      } else {
        window.onbeforeunload = function () {
          console.log('onbeforeunload')
          that.addBrowseLog()
        }
      }
    } else {
      //苹果
      window.addEventListener(
        'pagehide',
        function (e) {
          console.log('addBrowseLog-ios')
          that.addBrowseLog()
        },
        false
      )
    }
    // 闲置检测：监听用户交互事件，更新 lastActivityAt
    // 这样 read_time 反映"实际有交互的阅读时长"，而非"页面挂着的总时长"
    ;['scroll', 'touchstart', 'click'].forEach((evt) => {
      document.addEventListener(evt, this.recordActivity, { passive: true })
    })

    // 心跳：每 5 秒上报一次 + 检查"完成"条件
    // - clickId 未就绪 / 页面隐藏 / 闲置 > 30s → 跳过上报，但定时器继续 tick
    // - 完成事件触发后会清掉定时器，所以不会一直跑
    this.heartbeatTimer = setInterval(() => {
      if (!this.clickId || document.hidden) return
      const idleSec = (Date.now() - this.lastActivityAt) / 1000
      if (idleSec > 30) return // 闲置超 30 秒，read_time 不再增长
      // 文章渲染后才能监听末尾 marker；首次有 #show_content 时初始化
      if (!this.completionObserver) this.setupCompletionObserver()
      // PDF 页级 observer；canvas 异步渲染，首次就绪时初始化
      if (this.target_type == 2 && !this.pdfPageObserver) this.setupPdfPageObserver()
      this.addBrowseLog('heartbeat')
      // 完成条件 (b) 阅读时长 ≥ 3 分钟；(c) 已读最远位置 ≥ 70%
      // (a) 滑到底由 IntersectionObserver 触发，逻辑在 setupCompletionObserver
      // 3 分钟阈值：约等于客户真投入阅读 1500-3000 字课程内容 70% 的时间，
      // 比初版 60 秒更能过滤"客户挂着但没真读"的误报，信号更准。
      if (!this.completionFired) {
        const readSec = (Date.now() - this.openTime) / 1000
        if (readSec >= 180 || this.maxFinishRate >= 70) {
          this.fireCompletion(readSec >= 180 ? 'time-180s' : 'rate-70')
        }
      }
    }, 5000)
  },
  destroyed() {
    // 清理心跳定时器，避免内存泄漏 + 多余请求
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
    // 清理 IntersectionObserver
    if (this.completionObserver) {
      this.completionObserver.disconnect()
      this.completionObserver = null
    }
    if (this.pdfPageObserver) {
      this.pdfPageObserver.disconnect()
      this.pdfPageObserver = null
    }
    // 解绑 activity 监听
    ;['scroll', 'touchstart', 'click'].forEach((evt) => {
      document.removeEventListener(evt, this.recordActivity)
    })
    // if (window.removeEventListener) {
    //   window.removeEventListener('pagehide', this.unloadHandler)
    //   window.removeEventListener("unload", this.unloadHandler);
    // } else {
    //   window.unload = null
    // }
    // alert('destroyed')
    // this.unloadHandler()
  },
  methods: {
    // 记录最后一次用户交互时间，用于心跳里判断是否闲置
    recordActivity() {
      this.lastActivityAt = Date.now()
    },

    // PDF 页级 observer：监听每页 canvas 进入视口，记录已看到的最远页码
    // 必须等所有 canvas 画好（offsetHeight > 0）再挂 observer，否则未渲染的
    // 零高度 canvas 堆在视口顶部会被误判为"已看到"，导致完成率虚高。
    setupPdfPageObserver() {
      const container = this.$refs.pdfContainer
      if (!container) return
      const canvases = container.querySelectorAll('canvas')
      if (canvases.length === 0 || canvases.length < this.numPages) return
      const allPainted = Array.from(canvases).every(function (c) { return c.offsetHeight > 50 })
      if (!allPainted) return

      this.pdfPageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const pageNum = parseInt(entry.target.dataset.pdfPage, 10)
            if (pageNum > this.pdfMaxPageSeen) {
              this.pdfMaxPageSeen = pageNum
            }
            if (pageNum === this.numPages && !this.completionFired) {
              this.fireCompletion('pdf-last-page')
            }
          }
        })
      })

      canvases.forEach((canvas, index) => {
        canvas.dataset.pdfPage = index + 1
        this.pdfPageObserver.observe(canvas)
      })
    },

    // 在 #show_content 末尾插入一个 marker，监听它进入视口
    // = 客户真的滑到了文章底部 → 触发"完成"事件
    setupCompletionObserver() {
      const contentEl = document.getElementById('show_content')
      if (!contentEl) return // 文章还没渲染（PDF 类型或异步加载未完成）
      // 内容太短直接给 100% 完成率，不需要 marker
      if (contentEl.offsetHeight === 0) return

      const marker = document.createElement('div')
      marker.id = 'completion_marker'
      marker.style.cssText = 'height:1px;width:100%;'
      contentEl.appendChild(marker)

      this.completionObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.completionFired) {
          this.fireCompletion('scroll-to-end')
        }
      })
      this.completionObserver.observe(marker)
    },

    // 触发"完成"事件：上报一次完整 readCallback（不带 from=heartbeat）
    // 后端走通知/动态/标签 + redis 防重，确保员工最多收到 1 条阅读完成提醒
    // 触发后停心跳，避免后续心跳上报浪费请求
    fireCompletion(reason) {
      if (this.completionFired) return
      this.completionFired = true
      console.log('radar completion fired:', reason)
      this.addBrowseLog('complete')
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
        this.heartbeatTimer = null
      }
      if (this.completionObserver) {
        this.completionObserver.disconnect()
        this.completionObserver = null
      }
    },

    addBrowseLog(from = '') {
      const nDate = new Date().getTime()
      const ntime = nDate - this.openTime
      const time = this.toHHmmss(ntime)
      // 上报当前位置 + max 跟踪：取已读最远位置，避免客户从底部滑回顶部时
      // finish_rate 抖动下降。用户期望的"完成率"是单调上升的"读到哪了"。
      const current = this.getScrollTop()
      if (current > this.maxFinishRate) this.maxFinishRate = current
      const readData = {
        nickname: this.weChatUserData.nickname,
        radarId: this.radar_id,
        linkId: this.target_id,
        employeeId: this.staff_id,
        clickId: this.clickId,
        readTime: time,
        finishRate: this.maxFinishRate,
        // 心跳调用传 from=heartbeat，让后端跳过通知/动态/标签，避免每 5 秒刷屏
        from: from,
      }
      // let data = readData
      // let url =
      //   process.env.VUE_APP_API_BASE_URL +
      //   '/operation/radar/readCallback' +
      //   `?nickname=${this.this.weChatUserData.nickname}&radarId=${this.radar_id}&linkId=${this.target_id}&employeeId=${this.staff_id}&clickId=${this.clickId}&readTime=${time}&finishRate=${completionRate}`
      // let blob = new Blob([JSON.stringify(data)], {
      //   type: 'application/json; charset=UTF-8',
      // })
      let url =
        process.env.VUE_APP_API_BASE_URL + '/operation/radar/readCallback'
      const formData = new FormData()
      Object.keys(readData).forEach((key) => {
        let value = readData[key]
        if (typeof value !== 'string') {
          value = JSON.stringify(value)
        }
        formData.append(key, value)
      })
      navigator.sendBeacon(url, formData)
    },
    unloadHandler(e) {
      try {
        this.isPageBack = true
        const nDate = new Date().getTime()
        const ntime = nDate - this.openTime
        const time = this.toHHmmss(ntime)
        const completionRate = this.getScrollTop()
        const readData = {
          nickname: this.weChatUserData.nickname,
          radarId: this.radar_id,
          linkId: this.target_id,
          employeeId: this.staff_id,
          clickId: this.clickId,
          readTime: time,
          finishRate: completionRate,
        }
        this.ajax({
          url:
            process.env.VUE_APP_API_BASE_URL + '/operation/radar/readCallback',
          type: 'GET',
          data: readData,
          success: function (response, xml) {},
          fail: function (status) {},
        })
      } catch (e) {}
    },
    //跳转下载
    downloadPdf() {
      window.location.href = this.pdfData.pdf
    },
    //返回查看
    backSeek() {
      this.showPdf = false
    },
    //预览查看
    previewSeek() {
      this.showPdf = true
    },
    //获取用户数据
    getUserData() {
      let that = this
      openUserInfoApi({
        id: that.radar_id,
      }).then((res) => {
        if (res.data.openid === undefined) {
          let redirectUrl =
            '/auth/radar?id=' +
            that.radar_id +
            '&target=' +
            encodeURIComponent(that.url)
          that.$redirectAuth(redirectUrl)
        }
        this.weChatUserData = res.data
        this.getRadarData()
      })
    },
    //  获取数据
    getRadarData() {
      let params = {
        union_id: this.weChatUserData.unionid,
        nickname: this.weChatUserData.nickname,
        avatar: this.weChatUserData.headimgurl,
        target_type: this.target_type,
        radar_id: this.radar_id,
        target_id: this.target_id,
        staff_id: this.staff_id,
        openid: this.weChatUserData.openid
      }
      getRadarApi(params).then((res) => {
        this.clickId = res.data.clickId
        if (this.target_type == 1) {
          const flg = res.data.link.indexOf('http') == -1
          if (flg) {
            let link = res.data.link
            let path = window.location.protocol + '//' + link
            window.location.href = path
          }else{
            window.location.href = res.data.link
          }
        } else if (this.target_type == 2) {
          this.pdfData = res.data
          this.pafData(res.data.pdf)
          if (this.pdfData.employeeCard == 1) {
            this.userInfo = true
          }
          document.title = 'PDF查看'
        } else if (this.target_type == 3) {
          this.pdfData = res.data
          // this.pafData(res.data.pdf)
          this.articleData = res.data.article
          document.title = '文章查看'
          if (this.pdfData.employeeCard == 1) {
            this.userInfo = true
          }
        }
      })
    },
    //  浏览时间
    toHHmmss(data) {
      var time
      var hours = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = Math.ceil((data % (1000 * 60)) / 1000)
      if (Number(hours)) {
        time =
          (hours < 10 ? '0' + hours : hours) +
          '时' +
          (minutes < 10 ? '0' + minutes : minutes) +
          '分' +
          (seconds < 10 ? '0' + seconds : seconds) +
          '秒'
      } else if (Number(minutes)) {
        time =
          (minutes < 10 ? '0' + minutes : minutes) +
          '分' +
          (seconds < 10 ? '0' + seconds : seconds) +
          '秒'
      } else {
        time = (seconds < 10 ? '0' + seconds : seconds) + '秒'
      }

      return time
    },
    pafData(data) {
      this.pdfDataList = pdf.createLoadingTask(data)
      this.pdfDataList.promise.then((pdf) => {
        this.numPages = pdf.numPages
        this.pdfLoading = false
        this.$nextTick(() => this.setupPdfPageObserver())
      })
    },

    //  浏览程度（已读到的最远位置 / 内容总高度，0~100%）
    //
    // 文章场景优先用 #show_content 的 getBoundingClientRect 直接测，绕开
    // documentElement / body 在不同 webview 内核（X5 / WebView2 / Safari）下
    // clientHeight vs scrollHeight 行为不一致的问题。
    //
    // 历史教训：原算法用 body.clientHeight 当视口，但 body 被内容撑满后等于
    // 文档总高，公式恒 ≥100%。改成 documentElement.clientHeight 在桌面浏览器
    // 工作，但在微信 X5 内核里 documentElement 同样被内容撑大，仍然是 100%。
    // 直接用元素位置 + window.innerHeight 才稳。
    getScrollTop() {
      const viewHeight = window.innerHeight || document.documentElement.clientHeight || 0

      // 文章：基于 #show_content 元素位置算
      const contentEl = document.getElementById('show_content')
      if (contentEl && contentEl.offsetHeight > 0) {
        const rect = contentEl.getBoundingClientRect()
        // rect.top = 内容元素相对视口顶部的位置（已滚过的部分是负值）
        // viewHeight - rect.top = 视口底部相对内容顶部的位置 = 已读最远位置
        const scrolled = viewHeight - rect.top
        const progress = (scrolled / contentEl.offsetHeight) * 100
        return Math.min(Math.max(progress, 0), 100)
      }

      // PDF：基于 IntersectionObserver 记录的已看最远页码算
      // numPages 未就绪（PDF 还在加载）时也返回 0，绝不掉进 fallback
      if (this.target_type == 2) {
        if (this.numPages > 0 && this.pdfMaxPageSeen > 0) {
          return (this.pdfMaxPageSeen / this.numPages) * 100
        }
        return 0
      }

      // fallback：documentElement 算法
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop || 0
      const docHeight = Math.max(
        document.documentElement.scrollHeight || 0,
        document.body.scrollHeight || 0
      )
      if (docHeight <= viewHeight || docHeight === 0) {
        return 100
      }
      const progress = ((scrollTop + viewHeight) / docHeight) * 100
      return Math.min(Math.max(progress, 0), 100)
    },

    handleScroll() {
      const that = this
      debounce(() => {
        that.unloadHandler()
      }, 500)
    },

    ajax(options) {
      options = options || {}
      options.type = (options.type || 'GET').toUpperCase()
      options.dataType = options.dataType || 'json'
      var params = this.formatParams(options.data)

      //创建 - 非IE6 - 第一步
      if (window.XMLHttpRequest) {
        var xhr = new XMLHttpRequest()
      } else {
        //IE6及其以下版本浏览器
        var xhr = new ActiveXObject('Microsoft.XMLHTTP')
      }

      //接收 - 第三步
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          var status = xhr.status
          if (status >= 200 && status < 300) {
            options.success &&
              options.success(xhr.responseText, xhr.responseXML)
          } else {
            options.fail && options.fail(status)
          }
        }
      }

      //连接 和 发送 - 第二步
      if (options.type == 'GET') {
        xhr.open('GET', options.url + '?' + params, false)
        xhr.send(null)
      } else if (options.type == 'POST') {
        xhr.open('POST', options.url, false)
        //设置表单提交时的内容类型
        xhr.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded'
        )
        xhr.send(params)
      }
    },

    //格式化参数
    formatParams(data) {
      var arr = []
      for (var name in data) {
        arr.push(
          encodeURIComponent(name) + '=' + encodeURIComponent(data[name])
        )
      }
      arr.push(('v=' + Math.random()).replace('.', ''))
      return arr.join('&')
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .ant-modal-footer {
  display: none;
}
#show_content {
  /deep/img {
    width: 100%;
  }
}

.pdf_cont {
  padding-top: 57px;
  text-align: center;

  img {
    width: 75px;
    height: 75px;
  }

  .title {
    margin-top: 20px;
    color: #000;
    font-size: 17px;
  }
}

.back_view {
  padding-left: 25px;
  margin-top: 25px;
  font-size: 16px;
  display: inline-block;
}

.userInfo {
  display: flex;
  align-items: center;
  //justify-content: space-between;
  img {
    width: 40px;
    margin-right: 10px;
    height: 40px;
  }
}

.userQrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  img {
    width: 200px;
    height: 200px;
  }
}

.preview_seek {
  margin-top: 15px;
  font-size: 16px;
}

.article_page {
  padding: 15px;
  width: 100%;
  overflow-x: hidden;
}

/deep/ #js_content {
  visibility: visible !important;
}

/deep/ .rich_media_content {
  visibility: visible !important;
}

.article_title {
  font-weight: bold;
}
</style>
